import Command from '@ckeditor/ckeditor5-core/src/command';
import * as _ from "lodash-es";

import { CkeditorConstants } from '../../src/utils';

const {
  command: { CLICK },
  helperAttributes: { CONTENTEDITABLE }
} = CkeditorConstants;

export default class DisablePluginCommand extends Command {
  constructor(editor) {
    super(editor);

    this.pluginList = [
      'insertmedia',
      'blockQuote',
      'insertlink',
      'citation',
      'insertTable',
      'numberedList',
      'bulletedList',
      'insertText',
      'insertreference'
    ];
    this.pluginMap = new Map();

    this.prevNode = null;

    this.pluginList.forEach((pluginName) =>
      this.pluginMap.set(pluginName, this.editor.commands.get(pluginName))
    );
  }

  execute() {
    this.editor.fire('disablePlugin');
    this.refresh();
  }

  refresh() {
    this.editor.editing.view.document.on(CLICK, (event, { domTarget }) => {
      try {
        const isPrevNodeNotAvailable = !this.prevNode || !this.prevNode.isEqualNode(domTarget);
        const enableRequired =
          isPrevNodeNotAvailable && domTarget?.hasAttribute(CONTENTEDITABLE)
            ? domTarget.getAttribute(CONTENTEDITABLE) !== 'false'
            : _.find(
              event.source.selection.focus.getAncestors().reverse(),
              el => el._attrs && el.getAttribute(CONTENTEDITABLE)
            ).getAttribute(CONTENTEDITABLE) === 'true';

        this._enableDisablePlugins(enableRequired ? 'enable' : 'disable');
        isPrevNodeNotAvailable && (this.prevNode = domTarget);
      } catch (err) {
        console.log('Error upon click', err);
      }
    });

    this.editor.editing.view.document.on('blur', () => {
      this.prevNode = null;
    });
  }

  _enableDisablePlugins(status) {
    this.pluginMap.forEach((plugin) => {
      if (status === 'disable' && plugin.isEnabled) {
        plugin.forceDisabled();
      }

      if (status === 'enable' && !plugin.isEnabled) {
        plugin.clearForceDisabled();
      }
    });
  }
}
